// src/config.js
export const IMG_URL = 'https://charlotteandyou.cn/';
export const SENG_EMAIL = IMG_URL+'api/sendEmail'
